import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { Button, ConvertedComponentData, Image, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthImageTextBoxConverter extends CmsConverterService<FullWidthImageTextBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText, title),
      pointOfPicture: formData.st_image_point_of_picture?.value?.identifier ?? '',
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      button: {
        show: formData.st_show_button?.value ?? false,
        text: formData.st_button_text?.value ?? '',
        pageUid: formData.lt_button_link?.value?.identifier ?? '',
        anchor: formData.st_button_anchor?.value ?? '',
        target: '_self',
        uid: 'content_link'
      },
      alignImage: formData.st_image_alignment?.value?.identifier ?? ''
    }
  }
}

export const FULL_WIDTH_IMAGE_TEXT_BOX_TOKEN = new InjectionToken<Converter<CmsComponent, FullWidthImageTextBoxData>>(
  'FullWidthImageTextBoxConverter')

export interface FullWidthImageTextBoxData extends ConvertedComponentData {
  image: Image;
  pointOfPicture: string;
  headline: TextInput;
  text: TextInput;
  button: Button;
  alignImage: string;
}
